

/**
 * @description Controller for the invitation
 * @param {factory} InvitationFactory The service to deliver invitations
 * @param {unknown} $stateParams unknown
 * @param {unknown} moment The moment library
 * @param {unknown} $uibModal The $uibModal service from UI Bootstrap
 * @param {unknown} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {unknown} Notification The notification service
 * @param {library} _ The Lodash service
 */
function InvitationController(
  InvitationFactory,
  $stateParams,
  moment,
  $uibModal,
  NOTIFICATIONS,
  Notification,
  _
) {
  let vm = this;

  // Public methods
  vm.token = $stateParams.token;
  vm.type = $stateParams.type;

  // Pass the token and get the invitation
  InvitationFactory.getInvitation(vm.token).then(function(invitation) {
    if ('status' in invitation && invitation.status === 404) {
      vm.status = 'expired';
    } else if ('status' in invitation && invitation.status === 403) {
      vm.status = 'declined';
    } else {
      vm.status = 'invited';
      vm.collector = invitation.collector;
      vm.currentUsername = _.cloneDeep(invitation.collector.username);
      vm.shop = invitation.shop;
      vm.association = invitation.association;
      vm.created = moment(invitation.created);
      vm.createdBy = invitation.createdBy;

      if (vm.collector.is_new_user === true) {
        let modalInstance = $uibModal.open({
          template: require('./new-collector-modal.template.html'),
          animation: true,
          controller: 'NewCollectorModalController',
          bindToController: true,
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            collector: function() {
              return vm.collector;
            },
            token: function() {
              return vm.token;
            }
          }
        });
        modalInstance.result.then(function(collector) {
          vm.collector = collector;
        }, function() {
          // No Error reporting yet
        });
      }
    }
  });
}

angular
  .module('inkfinder')
  .controller('InvitationController', InvitationController);



// WEBPACK FOOTER //
// ./components/invitation/invitation.controller.js